import React from 'react'
import { RouteProp, useRoute } from '@react-navigation/native'
import { NavigationContainer } from '@src/screens/Common/containers'
import { getCoachingKindDescriptor } from '@utils'
import { AppStackParamList } from '@src/navigation/types'
import { CoachesCoachingKind } from '@src/types'
import { CoachSwitchComponent } from './CoachSwitchComponent'
import { useCoachSwitch } from './hooks/useCoachSwitch'

export const CoachSwitchScreen = () => {
  const route = useRoute<RouteProp<AppStackParamList, 'NutritionistSwitchScreen'>>()
  const { userInitiated = false, coachingKind = CoachesCoachingKind.Mnt } = route.params || {}
  const coachDescriptor = getCoachingKindDescriptor(coachingKind)
  const coachTitle = coachDescriptor.capitalized

  const { dismissNutritionistSwitch } = useCoachSwitch({ coachingKind })

  return (
    <NavigationContainer
      title={userInitiated ? `Switch ${coachTitle}` : `Confirm New ${coachTitle}`}
      goBack={dismissNutritionistSwitch}
    >
      <CoachSwitchComponent coachingKind={coachingKind} />
    </NavigationContainer>
  )
}
